module.exports = __webpack_public_path__ + "static/media/historic_georgian_banner_1.57453fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/historic_georgian_banner_1.png
// module id = 529
// module chunks = 0